import React from "react";
import { Button, Modal } from "react-bootstrap";
import Form from "../comman/form";
import Joi from "joi-browser";
import auth from "../services/authService";

class ForgetPassword extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      verify: false,
      hintQuestion: "",
    };
  }

  schema = {
    answer: Joi.string().required().label("Hint Answer"),
    newPassword: Joi.string().required().label("New Password"),
    confirmPassword: Joi.any()
      .valid(Joi.ref("newPassword"))
      .required()
      .options({ language: { any: { allowOnly: "must match new password" } } })
      .label("Confirm Password"),
  };

  schema1 = {
    username: Joi.string().required().label("User Name"),
  };

  schema2 = {
    email: Joi.string().email().required().label("Email Address"),
  };

  handleVerifyUser = async () => {
    const { data, errors } = this.state;
    const frmData = new FormData();
    frmData.append("username", data["username"]);
    frmData.append("email", data["email"]);
    const result = await auth.verifyUser(frmData);
    console.log(result);
    if (result === "Fail") {
      if (data["username"] !== "") errors["username"] = "User Not Found";
      else errors["email"] = "User Not Found";
    } else {
      this.setState({ verify: true, hintQuestion: result, errors });
    }
  };

  handleOnChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    const errors = { ...this.state.errors };
    const errorMessage = this.validateVerifyProperty(input);
    if (errorMessage) {
      errors[input.name] = errorMessage;
    } else {
      delete errors[input.name];
      if (input.name === "username") {
        data["email"] = "";
        delete errors["email"];
      }
      if (input.name === "email") {
        data["username"] = "";
        delete errors["username"];
      }
    }
    data[input.name] = input.value;
    this.setState({ data, errors });
  };

  validateVerifyProperty = ({ name, value }) => {
    const obj = { [name]: value };
    let schema = {};
    if (name === "username") {
      schema = { [name]: this.schema1[name] };
    } else {
      schema = { [name]: this.schema2[name] };
    }
    const { error } = Joi.validate(obj, schema);
    return error ? error.details[0].message : null;
  };

  doSubmit = async () => {
    const { data, errors } = this.state;
    const frmData = new FormData();
    frmData.append("username", data["username"]);
    frmData.append("email", data["email"]);
    frmData.append("answer", data["answer"]);
    frmData.append("newPassword", data["newPassword"]);
    const result = await auth.forgotPassword(frmData);
    console.log(result);
    if (result === "Fail") {
      errors["answer"] = "The provided security answer is not correct";
      this.setState({ errors });
    } else {
      this.props.handleModalShowHide();
    }
  };

  validate1 = () => {
    const options = { abortEarly: false, allowUnknown: true };
    const { data } = this.state;
    //console.log(data);
    let result = {};
    result = Joi.validate(data, this.schema1, options);
    //console.log(result.error);
    if (!result.error) return null;
    const errors = {};
    for (let item of result.error.details) errors[item.path[0]] = item.message;
    if (
      (data["email"] === undefined && data["username"] === undefined) ||
      (data["email"] === "" && data["username"] === "")
    )
      return errors;
    else return null;
  };

  render() {
    const { verify, hintQuestion, data, errors } = this.state;
    const { handleModalShowHide, showHide } = this.props;
    return (
      <Modal show={showHide}>
        <Modal.Header closeButton onClick={handleModalShowHide}>
          <Modal.Title>Forgot Password</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary">
          {!verify && (
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor="username" className="form-control-label">
                    User Name
                  </label>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    className="form-control"
                    onChange={this.handleOnChange}
                  ></input>
                  {errors["username"] && (
                    <div className="alert alert-danger">
                      {errors["username"]}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12 text-center">
                <label className="form-control-label">OR</label>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor="email" className="form-control-label">
                    Email Address
                  </label>
                  <input
                    type="text"
                    name="email"
                    id="email"
                    className="form-control"
                    onChange={this.handleOnChange}
                  ></input>
                  {errors["email"] && (
                    <div className="alert alert-danger">{errors["email"]}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12 text-center">
                <label className="form-control-label">OR</label>
              </div>
              <div className="col-md-12">
                {this.renderInput("phone", "Mobile (Text Message)")}
              </div>
            </div>
          )}
          {verify && (
            <div className="row">
              <div className="col-md-12 form-group">
                <label htmlFor="" className="form-control-label">
                  Your Security Question
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={hintQuestion}
                ></input>
              </div>
              <div className="col-md-12">
                {this.renderInput("answer", "Security Answer")}
              </div>
              <div className="col-md-6">
                {this.renderInput("newPassword", "New Password", "password")}
              </div>
              <div className="col-md-6">
                {this.renderInput(
                  "confirmPassword",
                  "Confirm Password",
                  "password"
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="danger" onClick={handleModalShowHide}>
            Close
          </Button> */}
          {!verify && (
            <button
              className="btn w-100"
              style={{ backgroundColor: "#3994fd" }}
              disabled={this.validate1()}
              onClick={this.handleVerifyUser}
            >
              Verify
            </button>
          )}
          {verify && (
            <button
              className="btn w-100"
              style={{ backgroundColor: "#3994fd" }}
              disabled={this.validate()}
              onClick={this.handleSubmit}
            >
              Change Password
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ForgetPassword;
